import React from "react";
import { Images } from "./Images";
import { useTranslation } from 'react-i18next';

const NewBookingTab = ({ activeTab, setActiveTab, setStep, tabAvailability = {} }) => {
    const { t } = useTranslation()

    const handleTabClick = (tab) => {
        if (!tabAvailability[tab]) {
            return;
        }

        setActiveTab(tab);
        setStep(0); // reset steps when tab changes
    };

    const getTabClassName = (tab) =>
        `step-tab ${activeTab === tab ? "active" : ""} ${tabAvailability[tab] ? "" : "disable"}`.trim();

    return (
        <div className="step-tabs"  id="tabHeader">

            <div
                className={getTabClassName("parking")}
                onClick={() => handleTabClick("parking")}
                aria-disabled={!tabAvailability.parking}
            >
                <img src={Images.GreenParking} alt="" />
                <h4>{t("parking")}</h4>
            </div>

            <div
                className={getTabClassName("desking")}
                onClick={() => handleTabClick("desking")}
                aria-disabled={!tabAvailability.desking}
            >
                <img src={Images.GreenDesking} alt="" />
                <h4>{t("react_desking")}</h4>
            </div>

            <div
                className={getTabClassName("meeting")}
                onClick={() => handleTabClick("meeting")}
                aria-disabled={!tabAvailability.meeting}
            >
                <img src={Images.GreenMeetingRoom} alt="" />
                <h4>{t("meetingroom")}</h4>
            </div>

        </div>
        
    );
};

export default NewBookingTab;
